import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// 모바일 키보드 올라올 때 포커스된 input을 뷰포트 위로 스크롤
if (window.visualViewport) {
  let lastHeight = window.visualViewport.height;
  window.visualViewport.addEventListener('resize', () => {
    const currentHeight = window.visualViewport.height;
    const keyboardOpen = currentHeight < lastHeight - 50;
    lastHeight = currentHeight;
    if (keyboardOpen && document.activeElement) {
      const tag = document.activeElement.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') {
        setTimeout(() => {
          document.activeElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 100);
      }
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
